import { createSelector } from 'reselect'
import uiSelector from './uiSelector'

const sidebarIsExpandedSelector = createSelector(
    uiSelector,
    (ui): boolean => ui.sidebarIsExpanded,
)

export default sidebarIsExpandedSelector
